import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { TypeResourceModel } from '../../models/academy/type-resource.model';
import { AcademyRepository } from '../../repositories/academy.repository';

export class GetAllTypeResourceUseCase implements UseCase<
  void,
  TypeResourceModel
> {
  constructor(private repository: AcademyRepository) {}

  execute(): Observable<TypeResourceModel> {
    return this.repository.getAllTypeResource();
  }
}
